<div id="global-loader" class="global-loader" *ngIf="isLoading">
  <div class="spinner"></div>
</div>

<div class="manage-department-container document-wrapper" [ngStyle]="{'max-height': scrHeight}">
  <div class="main-card">
    <!-- Header Section -->
    <div class="header-section">
      <div class="header-content">
        <div class="header-text">
          <h1>Manage Custom Departments</h1>
          <p>View and manage all departments with their team members — active and archived.</p>
        </div>
        <button class="btn-add-department" (click)="openAddDialog()">
          <mat-icon>add</mat-icon>
          Add Custom Department
        </button>
      </div>
    </div>

    <!-- Stats Cards -->
    <div class="stats-section">
      <div class="stat-card">
        <div class="stat-header">
          <div class="stat-icon active">
            <mat-icon>groups</mat-icon>
          </div>
          <div>
            <div class="stat-value">{{ getActiveCount() }}</div>
            <div class="stat-label">Active Departments</div>
          </div>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-header">
          <div class="stat-icon deleted">
            <mat-icon>archive</mat-icon>
          </div>
          <div>
            <div class="stat-value">{{ getArchivedCount() }}</div>
            <div class="stat-label">Archived Departments</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabs and Search Section -->
    <div class="tabs-search-section">
      <div class="tabs-container">
        <button
          class="tab-button"
          [class.active]="!showDeleted"
          (click)="setShowDeleted(false)">
          <span class="d-none d-sm-inline">Active List</span>
          <span class="d-inline d-sm-none">Active</span>
          <span class="tab-badge">{{ getActiveCount() }}</span>
        </button>
        <button
          class="tab-button"
          [class.active]="showDeleted"
          (click)="setShowDeleted(true)">
          <span class="d-none d-sm-inline">Archived List</span>
          <span class="d-inline d-sm-none">Archived</span>
          <span class="tab-badge">{{ getArchivedCount() }}</span>
        </button>
      </div>

      <div class="search-container">
        <mat-icon>search</mat-icon>
        <input
          class="search-input"
          type="text"
          [placeholder]="showDeleted ? 'Search archived departments...' : 'Search active departments...'"
          [(ngModel)]="searchText"
          (input)="setSearch(searchText)">
      </div>
    </div>

    <!-- Delete Confirmation Modal -->
    <div class="modal-backdrop show" *ngIf="showDeleteConfirmModal" (click)="cancelDelete()"></div>
    <div class="modal d-flex show" *ngIf="showDeleteConfirmModal" (click)="$event.stopPropagation()">
      <div class="modal-dialog modal-dialog-centered modal-dialog-custom m-auto">
        <div class="modal-content">
          <div class="modal-header border-0">
            <h5 class="modal-title fs-6 fw-bold m-0 d-flex align-items-center gap-2 text-danger">
              <mat-icon style="font-size: 26px;">error_outline</mat-icon><span>Confirm Delete</span>
            </h5>
            <button type="button" class="close-btn" (click)="cancelDelete()" title="Cancel">✕</button>
          </div>

          <hr class="divider" />

          <div class="modal-body">
            <p class="text-muted small mb-3">Are you sure you want to delete "<strong>{{ deleteConfirmTitle }}</strong>"?</p>
            <div class="delete-info-box">
              <div class="small text-muted">Note: Department will be moved to Archived List</div>
              <div class="small text-muted">You can restore this department from the Archived List if needed.</div>
            </div>
          </div>

          <hr class="divider" />

          <div class="modal-footer border-0">
            <button type="button" class="btn btn-outline-secondary btn-cancel" (click)="cancelDelete()" [disabled]="isProcessing">Cancel</button>
            <button type="button" class="btn btn-danger d-inline-flex align-items-center gap-1" (click)="confirmDelete()" [disabled]="isProcessing"><mat-icon>delete</mat-icon> Delete</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Departments List -->
    <div class="departments-list-section">
      <!-- Active departments -->
      <ng-container *ngIf="!showDeleted">
        <mat-accordion multi>
          <mat-expansion-panel
            *ngFor="let dept of filteredDepartments(); trackBy: trackByDeptId"
            class="color-group report-panel"
            (opened)="onPanelOpened(dept)">
            <mat-expansion-panel-header class="color-group-header">
              <div class="color-group-indicator">
                <button
                  type="button"
                  class="fav-star"
                  [class.is-fav]="dept.isFavorite"
                  (click)="toggleFavorite(dept, $event)"
                  [matTooltip]="dept.isFavorite ? 'Remove from favorites' : 'Add to favorites'"
                  aria-label="Toggle favorite">
                  <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
                    <path
                      d="M12 17.27 L18.18 21 L16.54 13.97 L22 9.24 L14.81 8.63 L12 2 L9.19 8.63 L2 9.24 L7.46 13.97 L5.82 21 Z"
                      [attr.fill]="dept.isFavorite ? '#cc0000' : 'none'"
                      [attr.stroke]="dept.isFavorite ? '#cc0000' : 'currentColor'"
                      stroke-width="2.25"
                    ></path>
                  </svg>
                </button>
                <!-- <div class="dept-icon">
                  <mat-icon>apartment</mat-icon>
                </div> -->
                <span class="color-name">{{ dept.name }}</span>
                <span class="member-badge">{{ dept.memberCount }} Members</span>
                <span class="status-chip status-chip--active">Active</span>
              </div>
            </mat-expansion-panel-header>

            <!-- Team Members -->
            <div class="team-members-section">
              <div class="team-members-title">
                <div style="display: inline-flex; align-items: center; gap:5px;"><mat-icon>group</mat-icon> Team Members ({{ dept.memberCount }})</div>
                
              
                <div class="dept-detail-actions">
                  <button type="button" class="btn-action btn-edit" (click)="editDepartment(dept, $event)">
                    <mat-icon>edit</mat-icon>
                    Edit
                  </button>
                  <button type="button" class="btn-action btn-delete" (click)="archiveDepartment(dept, $event)">
                    <mat-icon>delete</mat-icon>
                    Delete
                  </button>
                </div>
              </div>

              <div class="members-loading" *ngIf="dept.loadingMembers">
                <div class="spinner"></div><span>Loading team members...</span>
              </div>

              <div class="no-members" *ngIf="!dept.loadingMembers && filteredMembers(dept).length === 0">
                No team members in this department.
              </div>

              <div class="team-members-list" *ngIf="!dept.loadingMembers">
                <div class="team-member-row" *ngFor="let m of filteredMembers(dept); trackBy: trackByMemberId">
                  <div class="member-avatar">{{ getInitials(m.name) }}</div>
                  <div class="member-info">
                    <span class="member-name">{{ m.name }}</span>
                  </div>
                  <div class="member-email" *ngIf="m.email">
                    <mat-icon>mail_outline</mat-icon>
                    <span>{{ m.email }}</span>
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <div class="no-departments" *ngIf="filteredDepartments().length === 0">
          <mat-icon>groups</mat-icon>
          <p>{{ searchText ? 'No active departments match your search.' : 'No active departments found.' }}</p>
        </div>
      </ng-container>

      <!-- Archived departments -->
      <ng-container *ngIf="showDeleted">
        <!-- <div class="members-loading" *ngIf="isLoadingArchived">
          <div class="spinner"></div><span>Loading archived departments...</span>
        </div> -->

        <mat-accordion multi *ngIf="!isLoadingArchived">
          <mat-expansion-panel
            *ngFor="let dept of filteredDeletedDepartments(); trackBy: trackByDeptId"
            class="color-group report-panel"
            (opened)="onPanelOpened(dept)">
            <mat-expansion-panel-header class="color-group-header">
              <div class="color-group-indicator">
                <div class="dept-icon muted">
                  <mat-icon>apartment</mat-icon>
                </div>
                <span class="color-name">{{ dept.name }}</span>
                <span class="member-badge muted">{{ dept.memberCount }} Members</span>
                <span class="status-chip status-chip--archived">Archived</span>
              </div>
            </mat-expansion-panel-header>

            <!-- Team Members -->
            <div class="team-members-section">
              <div class="team-members-title">
                <div style="display: inline-flex; align-items: center; gap:5px;"><mat-icon>group</mat-icon> Team Members ({{ dept.memberCount }})</div>

                <div class="dept-detail-actions">
                  <button type="button" class="btn-action btn-restore" (click)="restoreDepartment(dept, $event)">
                    <mat-icon>restore</mat-icon>
                    Restore
                  </button>
                </div>
              </div>

              <div class="members-loading" *ngIf="dept.loadingMembers">
                <div class="spinner"></div><span>Loading team members...</span>
              </div>

              <div class="no-members" *ngIf="!dept.loadingMembers && filteredMembers(dept).length === 0">
                No team members in this department.
              </div>

              <div class="team-members-list" *ngIf="!dept.loadingMembers">
                <div class="team-member-row" *ngFor="let m of filteredMembers(dept); trackBy: trackByMemberId">
                  <div class="member-avatar">{{ getInitials(m.name) }}</div>
                  <div class="member-info">
                    <span class="member-name">{{ m.name }}</span>
                  </div>
                  <div class="member-email" *ngIf="m.email">
                    <mat-icon>mail_outline</mat-icon>
                    <span>{{ m.email }}</span>
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <div class="no-departments" *ngIf="!isLoadingArchived && filteredDeletedDepartments().length === 0">
          <mat-icon>inventory_2</mat-icon>
          <p>{{ searchText ? 'No archived departments match your search.' : 'No archived departments.' }}</p>
        </div>
      </ng-container>
    </div>

  </div>
</div>

<app-tutorial-video-widget
  screenId="manage-custom-department"
  title="Manage Custom Department walkthrough"
  teaserDescription="Watch a quick walkthrough of this screen."
  storageKey="manage-custom-department-tutorial-seen"
  teaserPosition="bottom-right"
  launcherPosition="bottom-right"
  [autoPlaySequence]="adminTutorialSequence"
  [allowLauncherDismiss]="true">
</app-tutorial-video-widget>

